export type NavItemKey =
  | "catalog"
  | "news"
  | "about"
  | "contacts"
  | "events"
  | "deposits"
  | "writers"
  | "account"
  | "admin"

const inSection = (pathname: string, base: string) => pathname === base || pathname.startsWith(`${base}/`)

export const isNavItemActive = (key: NavItemKey, pathname: string) => {
  switch (key) {
    case "catalog":
      return inSection(pathname, "/catalog")
    case "news":
      return inSection(pathname, "/news")
    case "about":
      return pathname === "/about"
    case "contacts":
      return inSection(pathname, "/contacts")
    case "events":
      return inSection(pathname, "/events")
    case "deposits":
      return inSection(pathname, "/deposits")
    case "writers":
      return inSection(pathname, "/writers")
    case "account":
      return inSection(pathname, "/account") || inSection(pathname, "/profile")
    case "admin":
      return inSection(pathname, "/admin")
    default:
      return false
  }
}
